import React from "react";
import { Flex, Text } from "@sqymagma/elements";
import * as S from "./style";
import { Team, GeneralClassificationTeam } from "./utils";
import { WidgetBox } from "@components";
import { THEMES } from "@constants";
import { useStyle } from "@contexts";
import leaf1 from "@images/leaf1.svg";
import leaf2 from "@images/leaf2.svg";
import leaf3 from "@images/leaf3.svg";
import leaf4 from "@images/leaf4.svg";

interface Props {
  teamsSteps?: Array<Team>;
  teamsGeneralClassification: Array<GeneralClassificationTeam>;
}

const Teams = (props: Props) => {
  const { teamsSteps, teamsGeneralClassification } = props;
  const { theme } = useStyle();
  const isDarkTheme = theme === THEMES.dark;

  return (
    <>
      <Flex
        m="auto"
        width={{ default: "100%", xl: "90%", xxl: "80%" }}
        flexDirection={{ default: "column", xl: "row" }}
        mb="xxl"
        mt="0"
      >
        {teamsSteps && !!teamsSteps.length && (
          <Flex flexDirection="column" mt="xl" mx="auto">
            <Flex pt="l" pl="xl">
              <Text textStyle="display02">Clasificación semanal</Text>
            </Flex>
            <Flex
              flexWrap="wrap"
              style={{ gap: "35px" }}
              justifyContent="flex-start"
              p="xl"
              mx="auto"
            >
              {teamsSteps.map((team, idx) => (
                <Flex
                  key={idx}
                  width="100%"
                  minWidth="100%"
                  flexGrow="2"
                  maxWidth="100%"
                  alignItems="center"
                >
                  <Text
                    textStyle="bodyLead"
                    color="text01"
                    width="20px"
                    textAlign="right"
                    mr="xs"
                  >
                    {idx + 1}
                  </Text>
                  {isDarkTheme ? (
                    <img
                      src={
                        Number(team.totalSteps) < 45000
                          ? leaf1
                          : Number(team.totalSteps) >= 45000 &&
                            Number(team.totalSteps) < 60000
                          ? leaf2
                          : Number(team.totalSteps) >= 60000 &&
                            Number(team.totalSteps) < 80000
                          ? leaf3
                          : leaf4
                      }
                      alt="medal"
                      width="40px"
                    />
                  ) : (
                    <img
                      src={
                        Number(team.totalSteps) < 45000
                          ? leaf1
                          : Number(team.totalSteps) >= 45000 &&
                            Number(team.totalSteps) < 60000
                          ? leaf2
                          : Number(team.totalSteps) >= 60000 &&
                            Number(team.totalSteps) < 80000
                          ? leaf3
                          : leaf4
                      }
                      alt="medal"
                      width="40px"
                    />
                  )}
                  <Flex flexDirection="column" ml="xs">
                    <Text mb="xxs" textStyle="display04" color="text01">
                      {team.name}
                    </Text>
                    <Text textStyle="body">
                      {Number(team.totalSteps).toLocaleString("es-ES")} pasos de
                      promedio
                    </Text>
                    <Text textStyle="body" mt="xxxs">
                      {`${
                        team.camelSteps.filter(
                          (participant) => participant.steps > 0
                        ).length
                      } participantes`}
                    </Text>
                  </Flex>
                </Flex>
              ))}
            </Flex>
          </Flex>
        )}
        {/* {teamsGeneralClassification && !!teamsGeneralClassification.length && (
          <WidgetBox
            borderColor="line01"
            borderWidth={0}
            borderStyle="solid"
            mt="xl"
            style={{ padding: 0 }}
            mx="auto"
          >
            <Flex pt="l" pl="xl">
              <Text textStyle="display02">Clasificación general</Text>
            </Flex>
            <Flex
              flexWrap="wrap"
              style={{ gap: "35px" }}
              justifyContent="flex-start"
              p="xl"
              mx="auto"
            >
              {teamsGeneralClassification.map((team, idx) => (
                <Flex
                  key={idx}
                  width="100%"
                  minWidth="100%"
                  flexGrow="2"
                  maxWidth="100%"
                  alignItems="center"
                >
                  <Text
                    textStyle="bodyLead"
                    color="text01"
                    width="20px"
                    textAlign="right"
                    mr="xs"
                  >
                    {idx + 1}
                  </Text>
                  {isDarkTheme ? (
                    <img src={leaf1} alt="medal" width="40px" />
                  ) : (
                    <img src={leaf1} alt="medal" width="40px" />
                  )}
                  <Flex flexDirection="column" ml="s">
                    <Text mb="xxs" textStyle="display04" color="text01">
                      {team.name}
                    </Text>
                    <Text textStyle="body">
                      {Number(team.totalSteps).toLocaleString("es-ES")} pasos
                    </Text>
                  </Flex>
                </Flex>
              ))}
            </Flex>
          </WidgetBox>
        )} */}
      </Flex>
    </>
  );
};

export default Teams;
